import { BOOKING_DETAILS, IRCTC_BOOKING_ID } from '../../../constants/ActionTypes';

const INITIAL_STATE = {
  bookingDetails: {
    bookingDetails: null,
    bookingStatusDetails: null,
    returnTripDetails: null,
    trainJourneyDetails: null,
    travellersDetails: null,
    priceBreakUp: null,
    importantInformation: null,
    confirmationGuaranteeDetails: null,
    gtmData: null,
  },
  irctcBookingId: '',
  verifiedUserId:  '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case BOOKING_DETAILS: {
    return {
      ...state,
      bookingDetails: action.payload.bookingDetails,
    };
  }
  case IRCTC_BOOKING_ID: {
    return {
      ...state,
      ...action.payload,
    };
  }
  default:
    return state;
  }
};
